import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/admin/users").then(r => setUsers(r.data)); }, []);
  return (
    <div data-testid="admin-users-page">
      <h1 className="editorial-heading text-4xl">Utenti ({users.length})</h1>
      <div className="mt-6 bg-card border border-border rounded-sm overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Nome</TableHead><TableHead>Email</TableHead><TableHead>Ruolo</TableHead><TableHead>Paese</TableHead><TableHead>Verificato</TableHead><TableHead>Azienda</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {users.map(u => (
              <TableRow key={u.id} data-testid={`user-row-${u.id}`}>
                <TableCell className="font-medium">{u.name}</TableCell>
                <TableCell>{u.email}</TableCell>
                <TableCell><span className="chip bg-[hsl(var(--muted))]">{u.role}</span></TableCell>
                <TableCell>{u.country || "—"}</TableCell>
                <TableCell>{u.verified ? "✓" : "—"}</TableCell>
                <TableCell>{u.company || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
